const tabsLink = document.querySelectorAll(".tabs-nav__link");

if (tabsLink) {
    window.addEventListener("load", () => {
        tabsLink.forEach((item) => {
            item.addEventListener("click", () => {
                tabsLink.forEach((item) => {
                    item.classList.remove("active");
                });
                item.classList.add("active");
            });
        });
    });
}
